// Single source of truth for "how complete is this profile" so the
// Profile page banner and the header nav badge never disagree.
export const PROFILE_COMPLETION_FIELDS = [
  {
    key: "photo",
    label: "Add a profile photo",
    weight: 10,
    isComplete: (data) => Boolean(data?.profile_photo_path),
  },
  {
    key: "full_name",
    label: "Add your full name",
    weight: 10,
    isComplete: (data) => Boolean(data?.full_name),
  },
  {
    key: "city",
    label: "Add your current city",
    weight: 10,
    isComplete: (data) => Boolean(data?.city || data?.living_state),
  },
  {
    key: "role",
    label: "Select your nursing role",
    weight: 15,
    isComplete: (data) => Boolean(data?.nursing_role?.role_title),
  },
  {
    key: "experience",
    label: "Add your years of experience",
    weight: 10,
    isComplete: (data) => Boolean(data?.nursing_experience),
  },
  {
    key: "career_objective",
    label: "Add your career objective",
    weight: 10,
    isComplete: (data) => Boolean(data?.career_objective?.length),
  },
  {
    key: "salary",
    label: "Add your preferred salary",
    weight: 10,
    isComplete: (data) => Boolean(data?.preferred_salary),
  },
  {
    key: "license_number",
    label: "Add your license number",
    weight: 10,
    isComplete: (data) => Boolean(data?.nurseProfile?.license_number),
  },
  {
    key: "resume",
    label: "Upload your resume",
    weight: 10,
    isComplete: (data) => data?.nurseProfile?.resume_uploaded === true,
  },
  {
    key: "social_profiles",
    label: "Add a social profile link",
    weight: 5,
    isComplete: (data) =>
      Boolean(
        data?.fb_profile_url ||
          data?.linkedin_profile_url ||
          data?.insta_profile_url,
      ),
  },
];

export const getProfileCompletionPercent = (profileData) => {
  if (!profileData) return 0;
  const totalWeight = PROFILE_COMPLETION_FIELDS.reduce(
    (sum, field) => sum + field.weight,
    0,
  );
  const earnedWeight = PROFILE_COMPLETION_FIELDS.filter((field) =>
    field.isComplete(profileData),
  ).reduce((sum, field) => sum + field.weight, 0);
  return Math.round((earnedWeight / totalWeight) * 100);
};
